import { t } from "i18next";

export const extractAddressDetails = (addressDetails) => {

    const {
    address1,
    address2,
    address3,
    town,
    county,
    countyCode,
    postcode,
    country,
    countryCode,
    companyName,
    firstName,
    lastName,
    email,
    partyId,
    ...rest
   }  = addressDetails
  
   return {
    ...rest, address: {
        address1,
        address2,
        address3,
        town,
        county,
        postcode,
        country,
        companyName,
        firstName,
        lastName,
        email,
        partyId,
        countyCode,
        countryCode

    }

   }
}

export function removeBlankFields(obj) {

  if (Array.isArray(obj)) {
    return obj.map(removeBlankFields);
  }

  if (obj !== null && typeof obj === "object") {
    return Object.entries(obj)
      .filter(([_, value]) => value !== "" && value !== null && value !== undefined)
      .reduce((acc, [key, value]) => {
        acc[key] = removeBlankFields(value);
        return acc;
      }, {});
  }

  return obj;

}

const getAddressLines = (
  address = {},
  company = {},
  includeCompany = false
) => {
  const addressFields = [
    'ADDRESS1',
    'ADDRESS2',
    'ADDRESS3',
    'TOWN',
    'COUNTY',
    'POSTCODE',
    'COUNTRY',
  ];

  return [
    ...(includeCompany && company?.COMPANY ? [company.COMPANY] : []),
    ...addressFields
      .map(field => address?.[field])
      .filter(line => line?.trim()),
  ];
};

export const AddressBlock = ({
  address,
  company,
  includeCompany = false,
  className = "address-block",
}) => {
  const addressLines = getAddressLines(
    address,
    company,
    includeCompany
  );

  return (
    <>{!includeCompany && <p><strong>{t('billingdetails.billingaddress')}</strong></p> }
    <div className={className}>
      {addressLines.map((line, index) => (
        <div key={index}>{line}</div>
      ))}
    </div>
   </> 
  );
};

//for gift- first check for isGift:true and then for isLatestGiftAddress:true and then for isLatestGift:true. Two recipients can have same addresses thus the last check is for latestRecipient
export const getPreferredAddress = (locations, { type, isGift = false, isPrint = false } = {}) => {
  if (!Array.isArray(locations) || locations.length === 0) return null;

  const latestKey = type === "delivery" ? "isLatestDelivery" : "isLatestBilling";
  const giftDelivery = isGift && type === "delivery";

  if (giftDelivery) {
    let validGiftRecords = locations.filter(location =>
      location.isGift === true
      && (!isPrint || location.address1 !== "")
    );
    if (validGiftRecords.length === 0) return null;

    if (validGiftRecords.length > 1) {
      const latestAddressRecords = validGiftRecords.filter(l => l.isLatestGiftAddress === true);
      if (latestAddressRecords.length > 0) validGiftRecords = latestAddressRecords;
    }
    if (validGiftRecords.length > 1) {
      const latestRecipientRecords = validGiftRecords.filter(l => l.isLatestGift === true);
      if (latestRecipientRecords.length > 0) validGiftRecords = latestRecipientRecords;
    }
    return validGiftRecords[0];
  }

  if (type === "delivery") {
    const renewed = locations.find(location =>
      location.isRenewedOrderDelivery === true
      && (!isPrint || location.address1 !== ""));
    if (renewed) return renewed;
  }

  let fallback = null;
  for (const location of locations) {
    if (location[latestKey] === true) return location;
    if (fallback === null && location.isLatest === true) fallback = location;
  }
  return fallback;
};

